<template>
    <Spin :spinning="loading">
        <Descriptions
            :title="$t('customerInfo')"
            layout="vertical"
            bordered
        >
            <DescriptionsItem :label="$t('name')">
                {{ customer.name }}
            </DescriptionsItem>
            <DescriptionsItem :label="$t('contactPerson')">
                {{ customer.contactPerson }}
            </DescriptionsItem>
            <DescriptionsItem :label="$t('createdAt')">
                {{ customer.createdAt | date }}
            </DescriptionsItem>
        </Descriptions>
    </Spin>
</template>

<script>
import { Descriptions, Spin } from 'ant-design-vue';
export default {
    name: 'CustomerInfo',
    components: {
        Descriptions,
        DescriptionsItem: Descriptions.Item,
        Spin,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        customer: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style>

</style>